export enum ConsentType {
    GST = 'GST',
    CREDIT_BUREAU = 'CREDIT_BUREAU',
}

export interface ConsentHistoryEntry {
    // Epoch millis (a JSON number), confirmed against aica's actual response body.
    consentedAt: number;
    gstin?: string;
    state?: string;
    gstUsername: string;
    actorName?: string;
    actorEmail?: string;
    actorRole?: string;
    ip?: string;
    accessedFrom?: string;
    device?: string;
}

export interface ConsentHistoryData {
    type: ConsentType;
    entries: ConsentHistoryEntry[];
    orgName: string;
}

export interface ConsentQueryParams {
    orgId: string;
    type: ConsentType;
}

export interface ConsentHistoryResponse {
    responseData: {
        responseCode: number;
        responseMessage?: string;
    };
    data?: ConsentHistoryData;
}

export interface ConsentAuditDrawerProps {
    open: boolean;
    onClose: () => void;
    loading: boolean;
    loadFailed: boolean;
    entries: ConsentHistoryEntry[];
    orgName?: string;
    onDownload: () => void;
    downloading: boolean;
}
